<head>
  <title>DMS Report</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row ps-0">
  <div class="col-md-8">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email" id="groupNameAlert"><b>Date Range</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedDateRangeValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of dateRangeValueDropdown | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-3">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
      <div class="col-md-3">
        <div><label for="email"><b>Interval</b> : </label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedIntervalValue" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of intervalValueDropdown | assessmentSearch : groupSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="row" d-flex align-items-center>
        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer" style="margin-top: 65px;">
            <button mat-stroked-button class="addButton" (click)="genReport()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Default'}" (click)="buttonClinkFun('Default')"
        (keydown.enter)="buttonClinkFun('Default')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Inventory'}" (click)="buttonClinkFun('Inventory')"
        (keydown.enter)="buttonClinkFun('Inventory')">
        <div class="reports_block">
          <img src="../../assets/img/stock-keeping-unit.png" width="16px" height="16px" alt="Inventory">
        </div>
        <p class="report_subtext">Inventory</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Master Index'}"
        (click)="buttonClinkFun('Master Index')" (keydown.enter)="buttonClinkFun('Master Index')">
        <div class="reports_block">
          <img src="../../assets/img/analysis.png" width="16px" height="16px" alt="Master Index">
        </div>
        <p class="report_subtext">Master Index</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Expiry Check'}"
        (click)="buttonClinkFun('Expiry Check')" (keydown.enter)="buttonClinkFun('Expiry Check')">
        <div class="reports_block">
          <img src="../../assets/img/calendarwhite.png" width="16px" height="16px" alt="Expiry Check">
        </div>
        <p class="report_subtext">Expiry Check</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Distributed Folder Documents Report'}"
        (click)="buttonClinkFun('Distributed Folder Documents Report')"
        (keydown.enter)="buttonClinkFun('Distributed Folder Documents Report')">
        <div class="reports_block">
          <img src="../../assets/img/claim-form.png" width="16px" height="16px"
            alt="Distributed Folder Documents Report">
        </div>
        <p class="report_subtext">Distributed Folder Documents Report</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Folder'}" (click)="buttonClinkFun('Folder')"
        (keydown.enter)="buttonClinkFun('Folder')">
        <div class="reports_block">
          <img src="../../assets/img/folder (3).png" width="16px" height="16px" alt="Folder">
        </div>
        <p class="report_subtext">Folder</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Milestone'}" (click)="buttonClinkFun('Milestone')"
        (keydown.enter)="buttonClinkFun('Milestone')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
        </div>
        <p class="report_subtext">Milestone</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Blinded'}" (click)="buttonClinkFun('Blinded')"
        (keydown.enter)="buttonClinkFun('Blinded')">
        <div class="reports_block">
          <img src="../../assets/img/hidden.png" width="16px" height="16px" alt="Blinded">
        </div>
        <p class="report_subtext">Blinded</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Unblinded'}" (click)="buttonClinkFun('Unblinded')"
        (keydown.enter)="buttonClinkFun('Unblinded')">
        <div class="reports_block">
          <img src="../../assets/img/DmsView.png" width="16px" height="16px" alt="Unblinded">
        </div>
        <p class="report_subtext">Unblinded</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Withdrawn'}" (click)="buttonClinkFun('Withdrawn')"
        (keydown.enter)="buttonClinkFun('Withdrawn')">
        <div class="reports_block">
          <img src="../../assets/img/withdrawWhite.png" width="16px" height="16px" alt="Withdrawn">
        </div>
        <p class="report_subtext">Withdrawn</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Deleted'}" (click)="buttonClinkFun('Deleted')"
        (keydown.enter)="buttonClinkFun('Deleted')">
        <div class="reports_block">
          <img src="../../assets/img/DeleteWhite.png" width="16px" height="16px" alt="Deleted">
        </div>
        <p class="report_subtext">Deleted</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Activity Vs User'}"
        (click)="buttonClinkFun('Activity Vs User')" (keydown.enter)="buttonClinkFun('Activity Vs User')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="Activity Vs User">
        </div>
        <p class="report_subtext">Activity Vs User</p>

      </div>
    </div>
  </div>
</div>
<br>
<hr>
<div class="row" *ngIf="showCharts">
  <div class="row">
    <div class="col-md-6" *ngIf="dmsCountList.length>0">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForDMSCount" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(1)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="dmsCountList.length==0">
      <div class="border rounded-4 p-2 mb-3">
        <label for="count"
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins',sans-serif;color:#0F3659;"><b>DMS
            Count</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"></span>
      </div>
    </div>

    <div class="col-md-6" *ngIf="statusList.length>0">
      <div class="border rounded-4 p-2 mb-3">
        <canvasjs-chart [options]="chartOptionsForStatus" [styles]="{width: '100%', height:'250px'}"
          (dblclick)="chartDoubleClick(2)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-6" *ngIf="statusList.length==0">
      <div class="border rounded-4 p-2 mb-3">
        <label for="Status"
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins',sans-serif;color:#0F3659;"><b>Status</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"></span>
      </div>
    </div>
    <div class="col-md-12" *ngIf="typeNameList.length>0">
      <div class="border rounded-4 p-2 mb-3 chart-container">
        <canvasjs-chart [options]="chartOptionsForDocType" [styles]="{width:chartWith, height:'250px'}"
          (dblclick)="chartDoubleClick(3)"></canvasjs-chart>
      </div>
    </div>
    <div class="col-md-12" *ngIf="typeNameList.length==0">
      <div class="border rounded-4 p-2 mb-3">
        <label for=" "
          style="text-align: left;font-size: 20px; font-weight: normal;font-family:'Poppins',sans-serif;color:#0F3659;"><b>Document
            Type</b></label>
        <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold;">
          <img src="../../assets/img/DMS/Error.png" alt="No DATA" style="width: 275px; height: 200px;"></span>
      </div>
    </div>
  </div>
</div>
<ng-template #reportPopupForZoom>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Documents Report</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="row">
    <div class="col-md-12" *ngIf="clickedChartVal==1">
      <canvasjs-chart [options]="chartOptionsForDMSCountZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12" *ngIf="clickedChartVal==2">
      <canvasjs-chart [options]="chartOptionsForStatusZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 chart-container" *ngIf="clickedChartVal==3">
      <canvasjs-chart [options]="chartOptionsForDocTypeZoom"
        [styles]="{width:chartWith, height:'250px'}"></canvasjs-chart>
    </div>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='1'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <table class="dynamic-table-container">
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Axis Value</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('axisValue', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Intervals</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('intervals', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Doc Container</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('docContainer', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Type Name</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentTypeName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document No.</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentNo', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Name</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentName', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('version', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Status</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('status', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Effective Date</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('effectiveDateStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Expiration Date</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('expirationDateStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Document ID</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocumentNo', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Document From Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocumentFromVersion', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Document To Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocumentToVersion', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Revision History</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('revisionHistory', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>CR Details</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('crDetails', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Description</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentDescription', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Folder Name</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('folderName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Folder Path</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('folderPath', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Folder Status</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('folderStatus', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>All Parent Folder Status</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('allParentFolderStatus', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Distributed Folder</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isDistributedFolder', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document Type Code</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('documentTypeCode', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Associated Document Type</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isAssociatedDocumentType', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Belongs To Individual</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('belongsToIndividual', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Assignable At Trainings</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('assignableAtTrainings', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Amendement Doc Type</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isAmendementDocType', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Associated Doc To Follow Same Expiry</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('associatedDocToFollowSameExpiry', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Belongs To User</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('belongsUserName', $event,'s')" />
        </div>
      </th>

      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkout Flag</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkoutFlag', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedout On</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedOutOn', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedout By User</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedoutByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedin On</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedinOnStr', $event,'n')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkedin By User</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkedinByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Checkinout Comments</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('checkinoutComments', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Latest Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isLatestVersion', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Latest Published Version</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isLatestPublishedVersion', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Blinded</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter('isBlinded', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Blinded By</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('blindedByName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Blinded On</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('blindedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Unblinded By</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('unblindedByName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Unblinded On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('unblindedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Unblind Reason</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('unblindReason', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Published On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('publishedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Published By</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('publishedByName', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Extension In Progress</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isExtensionInProgress', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Withdrawal In Progress</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isWithDrawalInProgress', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Is Amendment In Progress</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('isAmendmentInProgress', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>No. Of Completed Extension</span>

        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('noOfCompletedExtension', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>No. Of Completed Amendment</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('noOfCompletedAmendment', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Reason For Status Change</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('reasonForStatusChange', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Update Reason</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('updateReason', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Last Action On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('lastActionOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Last Action By</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('lastActionBy', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Last Action Comments</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('lastActionComments', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Created On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('createdOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Created By User</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('createdByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Updated On</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('updatedOnStr', $event,'d')" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Updated By User</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search"
            (input)="applyFilter('updatedByUser', $event,'s')" />
        </div>
      </th>
      <th class="sticky-col first-col"></th>
      <tr *ngIf="pagedItems.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
        <td class="row-data">{{ listOfUsersData.axisValue }}</td>
        <td class="row-data">{{ listOfUsersData.intervals }}</td>
        <td class="row-data">{{ listOfUsersData.docContainer }}</td>
        <td class="row-data">{{ listOfUsersData.documentTypeName }}</td>
        <td class="row-data">{{ listOfUsersData.documentNo }}</td>
        <td class="row-data">{{ listOfUsersData.documentName }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.effectiveDateStr }}</td>
        <td class="row-data">{{ listOfUsersData.expirationDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.associatedDocumentNo }}</td>
        <td class="row-data">{{ listOfUsersData.associatedDocumentFromVersion }}</td>
        <td class="row-data">{{ listOfUsersData.associatedDocumentToVersion }}</td>
        <td class="row-data">
          <div class="download-button-continer btn-align" mat-dialog-actions>
            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
              (click)="getClobData(listOfUsersData,'REVISION_HISTORY',listOfUsersData.revisionHistory,'DMS_INTERVALS_REP_VW')">
              <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
              <span class="ms-1" style="color:azure;">View</span>
            </button>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.crDetails }}</td>
        <td class="row-data">{{ listOfUsersData.documentDescription }}</td>
        <td class="row-data">{{ listOfUsersData.folderName }}</td>
        <td class="row-data">{{ listOfUsersData.folderPath }}</td>
        <td class="row-data">{{ listOfUsersData.folderStatus }}</td>
        <td class="row-data">{{ listOfUsersData.allParentFolderStatus }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isDistributedFolder === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isDistributedFolder === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.documentTypeCode }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isAssociatedDocumentType === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isAssociatedDocumentType === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.belongsToIndividual === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.belongsToIndividual === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.assignableAtTrainings === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.assignableAtTrainings === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isAmendementDocType === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isAmendementDocType === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.associatedDocToFollowSameExpiry === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.associatedDocToFollowSameExpiry === 'N'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.belongsUserName }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.checkoutFlag === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.checkoutFlag === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.checkedoutOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.checkedoutByUser}}</td>
        <td class="row-data">{{ listOfUsersData.checkedinOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.checkedinByUser }}</td>
        <td class="row-data">{{ listOfUsersData.checkinoutComments }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestVersion === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestVersion === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isBlinded === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isBlinded === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.blindedByName }}</td>
        <td class="row-data">{{ listOfUsersData.blindedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.unblindedByName }}</td>
        <td class="row-data">{{ listOfUsersData.unblindedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.unblindReason }}</td>
        <td class="row-data">{{ listOfUsersData.publishedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.publishedByName }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isExtensionInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img
              *ngIf="listOfUsersData.isExtensionInProgress === 'N' ||listOfUsersData.isExtensionInProgress === '' ||listOfUsersData.isExtensionInProgress ===null||listOfUsersData.isExtensionInProgress ==='null'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isWithdrawalInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isWithdrawalInProgress === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isAmendmentInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img
              *ngIf="listOfUsersData.isAmendmentInProgress === 'N' ||listOfUsersData.isAmendmentInProgress === '' ||listOfUsersData.isAmendmentInProgress ===null||listOfUsersData.isAmendmentInProgress ==='null'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.noOfCompletedExtension }}</td>
        <td class="row-data">{{ listOfUsersData.noOfCompletedAmendment }}</td>
        <td class="row-data">{{ listOfUsersData.reasonForStatusChange }}</td>
        <td class="row-data">{{ listOfUsersData.updateReason }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
        <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
      </tr>
    </table>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!--detail grid-->
<ng-template #reportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">{{clickedType}} : {{clickedVal}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="table-container" *ngIf="showReportFlagValue=='1'">
    <div class="row">
      <div class="col-8"></div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Axis Value</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('axisValue', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Intervals</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('intervals', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Doc Container</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('docContainer', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Document Type Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('documentTypeName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Document No.</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('documentNo', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Document Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('documentName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Version</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('version', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('status', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Effective Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('effectiveDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Expiration Date</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('expirationDateStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Associated Document ID</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('associatedDocumentNo', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Associated Document From Version</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('associatedDocumentFromVersion', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Associated Document To Version</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('associatedDocumentToVersion', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Revision History</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('revisionHistory', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>CR Details</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('crDetails', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Document Description</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('documentDescription', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Folder Name</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('folderName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Folder Path</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('folderPath', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Folder Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('folderStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>All Parent Folder Status</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('allParentFolderStatus', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Distributed Folder</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isDistributedFolder', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Document Type Code</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('documentTypeCode', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Associated Document Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isAssociatedDocumentType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Belongs To Individual</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('belongsToIndividual', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Assignable At Trainings</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('assignableAtTrainings', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Amendement Doc Type</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isAmendementDocType', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Associated Doc To Follow Same Expiry</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('associatedDocToFollowSameExpiry', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Belongs To User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('belongsUserName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Checkout Flag</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('checkoutFlag', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Checkedout On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('checkedOutOn', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Checkedout By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('checkedoutByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Checkedin On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('checkedinOnStr', $event,'n')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Checkedin By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('checkedinByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Checkinout Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('checkinoutComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Latest Version</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isLatestVersion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Latest Published Version</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isLatestPublishedVersion', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Blinded</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isBlinded', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Blinded By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('blindedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Blinded On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('blindedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Unblinded By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('unblindedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Unblinded On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('unblindedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Unblind Reason</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('unblindReason', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Published On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('publishedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Published By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('publishedByName', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Extension In Progress</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isExtensionInProgress', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Withdrawal In Progress</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isWithDrawalInProgress', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Is Amendment In Progress</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('isAmendmentInProgress', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>No. Of Completed Extension</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('noOfCompletedExtension', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>No. Of Completed Amendment</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('noOfCompletedAmendment', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Reason For Status Change</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('reasonForStatusChange', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Update Reason</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updateReason', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action By</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionBy', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Last Action Comments</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('lastActionComments', $event,'s')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Created By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('createdByUser', $event,'s')" />
            </div>
          </th>

          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated On</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedOnStr', $event,'d')" />
            </div>
          </th>
          <th class="sticky-dynamic-col1 dynamic-table-header-style">
            <span>Updated By User</span>
            <div class="row-search-container">
              <input type="text" class="form-control" placeholder="Search"
                (input)="applyFilter('updatedByUser', $event,'s')" />
            </div>
          </th>
          <th class="sticky-col first-col"></th>
        </thead>
        <tr *ngIf="pagedItems.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems; let idx = index;">
          <td class="row-data">{{ listOfUsersData.axisValue }}</td>
          <td class="row-data">{{ listOfUsersData.intervals }}</td>
          <td class="row-data">{{ listOfUsersData.docContainer }}</td>
          <td class="row-data">{{ listOfUsersData.documentTypeName }}</td>
          <td class="row-data">{{ listOfUsersData.documentNo }}</td>
          <td class="row-data">{{ listOfUsersData.documentName }}</td>
          <td class="row-data">{{ listOfUsersData.version }}</td>
          <td class="row-data">{{ listOfUsersData.status }}</td>
          <td class="row-data">{{ listOfUsersData.effectiveDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.expirationDateStr}}</td>
          <td class="row-data">{{ listOfUsersData.associatedDocumentNo }}</td>
          <td class="row-data">{{ listOfUsersData.associatedDocumentFromVersion }}</td>
          <td class="row-data">{{ listOfUsersData.associatedDocumentToVersion }}</td>
          <td class="row-data">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="getClobData(listOfUsersData,'REVISION_HISTORY',listOfUsersData.revisionHistory,'DMS_INTERVALS_REP_VW')">
                <img src="../../../assets/img/view.png" width="12px" height="12px" alt="view">
                <span class="ms-1" style="color:azure;">View</span>
              </button>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.crDetails }}</td>
          <td class="row-data">{{ listOfUsersData.documentDescription }}</td>
          <td class="row-data">{{ listOfUsersData.folderName }}</td>
          <td class="row-data">{{ listOfUsersData.folderPath }}</td>
          <td class="row-data">{{ listOfUsersData.folderStatus }}</td>
          <td class="row-data">{{ listOfUsersData.allParentFolderStatus }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isDistributedFolder === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isDistributedFolder === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>

          <td class="row-data">{{ listOfUsersData.documentTypeCode }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isAssociatedDocumentType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isAssociatedDocumentType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.belongsToIndividual === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.belongsToIndividual === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.assignableAtTrainings === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.assignableAtTrainings === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isAmendementDocType === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isAmendementDocType === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.associatedDocToFollowSameExpiry === 'Y'"
                src="../../assets/img/accessSymbol.svg" width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.associatedDocToFollowSameExpiry === 'N'"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.belongsUserName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.checkoutFlag === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.checkoutFlag === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.checkedoutOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.checkedoutByUser}}</td>
          <td class="row-data">{{ listOfUsersData.checkedinOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.checkedinByUser }}</td>
          <td class="row-data">{{ listOfUsersData.checkinoutComments }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isLatestVersion === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isLatestVersion === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isLatestPublishedVersion === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isBlinded === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isBlinded === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
                height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.blindedByName }}</td>
          <td class="row-data">{{ listOfUsersData.blindedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.unblindedByName }}</td>
          <td class="row-data">{{ listOfUsersData.unblindedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.unblindReason }}</td>
          <td class="row-data">{{ listOfUsersData.publishedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.publishedByName }}</td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isExtensionInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img
                *ngIf="listOfUsersData.isExtensionInProgress === 'N' ||listOfUsersData.isExtensionInProgress === '' ||listOfUsersData.isExtensionInProgress ===null||listOfUsersData.isExtensionInProgress ==='null'"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isWithdrawalInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img *ngIf="listOfUsersData.isWithdrawalInProgress === 'N'" src="../../assets/img/noAcessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">
            <div class="icon-container">
              <img *ngIf="listOfUsersData.isAmendmentInProgress === 'Y'" src="../../assets/img/accessSymbol.svg"
                width="20" height="20" alt="Access granted symbol">
              <img
                *ngIf="listOfUsersData.isAmendmentInProgress === 'N' ||listOfUsersData.isAmendmentInProgress === '' ||listOfUsersData.isAmendmentInProgress ===null||listOfUsersData.isAmendmentInProgress ==='null'"
                src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            </div>
          </td>
          <td class="row-data">{{ listOfUsersData.noOfCompletedExtension }}</td>
          <td class="row-data">{{ listOfUsersData.noOfCompletedAmendment }}</td>
          <td class="row-data">{{ listOfUsersData.reasonForStatusChange }}</td>
          <td class="row-data">{{ listOfUsersData.updateReason }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionOnStr}}</td>
          <td class="row-data">{{ listOfUsersData.lastActionByUser }}</td>
          <td class="row-data">{{ listOfUsersData.lastActionComments }}</td>
          <td class="row-data">{{ listOfUsersData.createdOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
          <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
          <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        </tr>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <div class="width-cheat small paginationCell">
        <div class="d-flex align-items-center gap-3">
          <div class="pagination_text mt-3">
            {{ showingRowsText }}
            1-{{ perPage }} of {{ collectionSize | number }}
          </div>
          <div>
            <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
              [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
              [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
            </ngb-pagination>
          </div>
          <div ngbDropdown class="mt-3">
            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
              {{ perPage }}
              <i class="ms-1 fa-solid fa-chevron-down"></i>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
              <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
              <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
            </div>
            per page
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>


      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
            (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
            (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">

            <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label for="email">Report Name</label>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>
      </div>

    </div>

    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
          (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>